import { Loader } from '@googlemaps/js-api-loader';

import { useMemo } from 'react';

import { getConfig } from '../../utils/getConfig.js';

export const useGoogleMapsLoader = () =>
  useMemo(
    () =>
      new Loader({
        // google is finicky about these options; there can be only
        // one set of options, even if you use multiple loaders all
        // over the place. so, if this isn't working, you can't make
        // another loader--you need to update our google cloud creds
        // to include the services you need, and update the libraries
        // list to include the one you want.
        apiKey: getConfig('GOOGLE_MAPS_API_KEY'),
        libraries: ['streetView', 'places'],
      }),
    [],
  );
